var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"TeamMemberImage"},[_c('Pic',{attrs:{"src":(_vm.member.image[0] || _vm.member.image).url}}),_c('a',{staticClass:"linkedin",attrs:{"href":_vm.member.linkedin,"rel":"noopener","target":"_blank","title":`${_vm.member.name} LinkedIn`}},[_c('Icon',{attrs:{"name":"linkedin"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }